module.exports = __webpack_public_path__ + "media/images/icons/icon-mms-1dca2ddddce266f1a8e87e85f8f3c698.png";